// extracted by mini-css-extract-plugin
export default {"modal__footer":"Modal_modal__footer__Dxsld","invoice__deatail":"Modal_invoice__deatail__Liewx","modal__body":"Modal_modal__body__vnW0s"};